import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import { vignettesList_template } from "../components/templates/vignettesList_template";

declare var ko: any;
declare var page: any;

export class vignettes extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: vignettesList_template;
    protected pagination: pagination_template;
    protected timer;

    protected getModuleName(){

        return "vignettes";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new vignettesList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Vignette List");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.elementsList.setIdBrand(idBrand);
        }
        this.getfilterReference();
    }

    public addVignette(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        this.saveViewModule(this.getMemoryViewModel());
        page(`/brand/${this.getVnAppZone().app.params.idBrand}/categorization/vignettes/add/`);
    }

    public viewVignette(idVignette: number){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        this.saveViewModule(this.getMemoryViewModel());
        page(`/brand/${this.getVnAppZone().app.params.idBrand}/categorization/vignettes/view/${idVignette}`);
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }
    
    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    public getfilterReference(): void{

        if( "getfilterReference" in this.XHRHdls ){
            this.XHRHdls["getfilterReference"].cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/vignettes/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['vignettesListRequest', 'true']);
        this.XHRHdls['getfilterReference'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getfilterReference'].onReadyStateFunction = this.onFilterReferenceRequestReturn;
        this.XHRHdls['getfilterReference'].execute();
    }

    protected onFilterReferenceRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setBrands(responseParsed.brands);
                obj.filterList();
            });
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = `/api/brand/${idBrand}/tags/vignettes/get/`;
        this.timer = new Date().getTime();
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'vignettes');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.updateViewModelFromPath();
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    protected updateList(responseParsed: any){

        this.elementsList.setVignettes(responseParsed.data);

        let execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.tags;

        return templateViewModel;
    }
}


// WEBPACK FOOTER //
// ./js/modules/vignettes.ts